import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.b4{opacity:0;}.ssr-plugin'
import '.dd{animation:voting-open-soon-title-slide-in 0.6s ease-out 0.2s forwards;}.ssr-plugin'
import '.b6{margin-bottom:72px;}.ssr-plugin'
import '.de{animation:voting-open-soon-title-slide-in 0.6s ease-out forwards;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.df{margin-bottom:42px;}.ssr-plugin'
import { colors } from '../utils/colors.js'
import { styled } from 'inlines'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { Layout } from '../components/Layout.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { CountdownTimer } from '../components/CountdownTimer.js'
import { useVotingRegion } from '../hooks/useVotingRegion.js'
import { formatTimeByZone } from '../utils/parseTime.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { useEffect } from 'react'

export const ContentPage = ({ rounds, ...data }) => {
  let { title, description, countdown } = data

  const {
    onlineDescription,
    phoneDescription,
    startVotingNow,
    votingIsClosed,
  } = useDictionary()

  const [votingRegion] = useVotingRegion()

  const maxVotes = votingRegion?.maxVotes
  const price = votingRegion?.formattedPrice

  const track = useTrack('voting-will-open-soon')
  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  if (votingRegion.locale === undefined)
    console.warn('ContentPage: votingRegion.locale missing')
  const locale = votingRegion.locale || 'en-US' // SAFE: fallback to en-US when locale not yet loaded

  const roundTimes: Record<string, string> = {}
  if (rounds) {
    for (const round of Object.values(rounds)) {
      const { name, showtime } = round as any

      roundTimes[name] = formatTimeByZone(showtime as any, locale)
    }
  }

  if (title) {
    title = title
      .replace(/{{START_VOTING_NOW}}/g, startVotingNow ?? '')
      .replace(/{{DICTIONARY.VOTINGISCLOSED}}/g, votingIsClosed ?? '')
  }

  if (description && Object.keys(roundTimes).length !== 0) {
    description = description
      .replace(/{{SEMI1_SHOWTIME}}/g, roundTimes?.semi1 ?? '')
      .replace(/{{SEMI2_SHOWTIME}}/g, roundTimes?.semi2 ?? '')
      .replace(/{{FINAL_SHOWTIME}}/g, roundTimes?.final ?? '')
      .replace(/{{ONLINE_DESCRIPTION}}/g, onlineDescription ?? '')
      .replace(/{{PHONE_DESCRIPTION}}/g, phoneDescription ?? '')
      .replace(/{{MAX_VOTES}}/g, maxVotes !== undefined ? String(maxVotes) : '')
      .replace(/{{PRICE}}/g, price ?? '')
  }

  const titleParts: string[] =
    title && /<accent>.*?<\/accent>/.test(title)
      ? title.split(/<accent>(.*?)<\/accent>/g)
      : title

  return (
    <Layout
      style={{
        [MOBILE]: {
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingBottom: '0px',
        },
      }}
    >
      <style>{`
        @keyframes voting-open-soon-title-slide-in {
          from { opacity: 0; transform: translateY(48px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <h1 className="cr b4 dd"
        style={{
          color: colors.red,}}
      >
        {typeof titleParts !== 'string' ? titleParts?.[1] : title}
      </h1>
      {typeof titleParts !== 'string' && (
        <styled.h2 className="b6 b4 de"
          style={{
            [TABLET]: {
              marginBottom: 36,
            },
            [MOBILE]: {
              marginBottom: 24,
            },
          }}
        >
          {titleParts?.[2]}
        </styled.h2>
      )}
      {!!countdown && (
        <CountdownTimer
          targetTimestamp={countdown}
          style={{ width: '100%', marginBottom: 96 }}
        />
      )}
      <p className="cp df">
        {description}
      </p>
    </Layout>
  )
}
